// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { ApiParameter, get, post } from "@insite/client-framework/Services/ApiService";
import translate from "@insite/client-framework/Translate";
import { RoleTranslationModel } from "@vanmeter/App/Store/Reducers";

const systemListByNameUri = "/api/vmi/systemlist/GetListByName";
const assignUserRolesUri = "/api/vmi/roles/AssignRoles";

export interface AssignedRolesModel {
    id: string;
    approver: string;
    Roles: string[];
}

export async function getRoleTranslations() {
    try {
        const result = await get<RoleTranslationModel[]>(systemListByNameUri, {
            name: "Roles",
        } as ApiParameter);
        return {
            successful: true,
            result,
        };
    } catch (error) {
        return {
            successful: false,
            errorMessage: error?.errorJson?.message ?? translate("An error occured."),
        };
    }
}

export async function assignRolesToUser(parameter: AssignedRolesModel) {
    try {
        await post(assignUserRolesUri, parameter);
        return {
            successful: true,
        };
    } catch (error) {
        return {
            successful: false,
            errorMessage: error?.errorJson?.message || translate("An error occured."),
        };
    }
}
